// // src/pages/TownPlanningDashboard.js
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import styles from "../styles/TownPlanningDashboard.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faUniversity,
//   faFileSignature,
//   faBullhorn,
//   faFileAlt,
//   faEnvelopeOpenText,
//   faBalanceScale,
//   faLandmark,
//   faFile,
//   faBars,
//   faFilter,
//   faRobot,
//   faSearch,
//   faCalculator,
//   faBook,
//   faNewspaper,
//   faUserGraduate,
// } from "@fortawesome/free-solid-svg-icons";
// import homeIMG from "../assets/town_planner_final.png";
// import TownPlanningSidebar from "../components/TownPlanningSidebar";
// import FilterPopup from "../components/FilterPopup";
// import { useAppContext } from "../context";
// import ChatbotPanel from "../components/ChatbotPanel"; // ⬅️ Add at top
// import { faComments } from "@fortawesome/free-solid-svg-icons"; // ⬅️ Add icon import
// export default function TownPlanningDashboard() {
//   const navigate = useNavigate();
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   //const { setSelectedCategory, setSearchText } = useAppContext(); // ✅ use context
//     const { selectedCategory, searchText, setSearchText, filter, setFilter, setSelectedCategory } = useAppContext();
  
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showFilter, setShowFilter] = useState(false);
//   const [showChatbot, setShowChatbot] = useState(false);

//   const handleCardClick = (category) => {
//      setFilter({
//     mainCategory: "",
//     subCategory: "",
//     subSubCategory: "",
//   });
//     setSelectedCategory(category);
//         setSearchText(""); // clear any old search

//     navigate("/documents");
//   };

//   const handleCalculatorClick = () => {
//     navigate("/area-convertor");
//   };

//   // ✅ handle search button click
//   const handleSearch = () => {
//     if (searchTerm.trim() !== "") {
//       setSelectedCategory(null); // show all categories in DocumentList
//       setSearchText(searchTerm); // pass entered text to context
//       navigate("/documents"); // redirect to DocumentList
//     }
//   };

//   return (
//     <div className={styles.homeScreenContainer}>
//       {/* Top Navbar */}
//       <div className={styles.homeScreenHeader}>
//         <button onClick={() => setIsSidebarOpen(true)} className={styles.homeScreenMenuBtn}>
//           <FontAwesomeIcon icon={faBars} />
//         </button>
//         <TownPlanningSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
//         <div className={styles.homeScreenLogoSection}>
//           <img src={homeIMG} alt="Town Planning Helpline" className={styles.homeScreenLogoImage} />
//         </div>
//       </div>

//       {/* Search Bar */}
//       <div className={styles.homeScreenSearchContainer}>
//         <input
//           type="text"
//           placeholder="Search By Name or Date"
//           className={styles.homeScreenSearchInput}
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <button className={styles.homeScreenSearchButton} onClick={handleSearch}>
//           <FontAwesomeIcon icon={faSearch} />
//         </button>
//       </div>

//       {/* Grid of Categories */}
//       <div className={styles.homeScreenIconGrid}>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Act")}>
//           <FontAwesomeIcon icon={faUniversity} className={styles.homeScreenIcon} />
//           <p>Acts</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Rule")}>
//           <FontAwesomeIcon icon={faFileSignature} className={styles.homeScreenIcon} />
//           <p>Rules</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Directive")}>
//           <FontAwesomeIcon icon={faBullhorn} className={styles.homeScreenIcon} />
//           <p>Directives</p>
//         </div>

//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("GR")}>
//           <FontAwesomeIcon icon={faFileAlt} className={styles.homeScreenIcon} />
//           <p>GR</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Circulars")}>
//           <FontAwesomeIcon icon={faEnvelopeOpenText} className={styles.homeScreenIcon} />
//           <p>Circular</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Landmark Judgement / Orders")}>
//           <FontAwesomeIcon icon={faBalanceScale} className={styles.homeScreenIcon} />
//           <p>Courts</p>
//         </div>

//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Government Scheme and Policy")}>
//           <FontAwesomeIcon icon={faLandmark} className={styles.homeScreenIcon} />
//           <p>Schemes</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Formats")}>
//           <FontAwesomeIcon icon={faFile} className={styles.homeScreenIcon} />
//           <p>Formats</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Books")}>
//           <FontAwesomeIcon icon={faBook} className={styles.homeScreenIcon} />
//           <p>Books</p>
//         </div>

//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("Articles")}>
//           <FontAwesomeIcon icon={faNewspaper} className={styles.homeScreenIcon} />
//           <p>Articles</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={() => handleCardClick("TP Career")}>
//           <FontAwesomeIcon icon={faUserGraduate} className={styles.homeScreenIcon} />
//           <p>TP Career</p>
//         </div>
//         <div className={styles.homeScreenIconCard} onClick={handleCalculatorClick}>
//           <FontAwesomeIcon icon={faCalculator} className={styles.homeScreenIcon} />
//           <p>Calculator</p>
//         </div>

//       </div>

//       {/* Floating Buttons */}
//       <button
//         className={`${styles.homeScreenFloatingBtn} ${styles.homeScreenFilterBtn}`}
//         onClick={() => setShowFilter(true)}
//       >
//         <FontAwesomeIcon icon={faFilter} />
//       </button>


//       <button
//         className={`${styles.homeScreenFloatingBtn} ${styles.homeScreenChatBtn}`}
//         onClick={() => setShowChatbot((prev) => !prev)}
//       >
//         <FontAwesomeIcon icon={faComments} />
//       </button>

//       {showChatbot && <ChatbotPanel onClose={() => setShowChatbot(false)} />}

//       {showFilter && <FilterPopup onClose={() => setShowFilter(false)} />}
//     </div>
//   );
// }




import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Menu, 
  Search, 
  Filter, 
  MessageCircle, 
  University, 
  FileSignature, 
  Megaphone, 
  FileText, 
  MailOpen, 
  Scale, 
  Landmark, 
  FileCode, 
  Book, 
  Newspaper, 
  GraduationCap, 
  Calculator,
  X
} from "lucide-react";

import homeIMG from "../assets/town_planner_final.png";
import TownPlanningSidebar from "../components/TownPlanningSidebar";
import FilterPopup from "../components/FilterPopup";
import { useAppContext } from "../context";
import ChatbotPanel from "../components/ChatbotPanel";

export default function TownPlanningDashboard() {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { setSearchText, setFilter, setSelectedCategory } = useAppContext();

  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showChatbot, setShowChatbot] = useState(false);

  const handleCardClick = (category) => {
    setFilter({ mainCategory: "", subCategory: "", subSubCategory: "" });
    setSelectedCategory(category);
    setSearchText(""); 
    navigate("/documents");
  };

  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      setSelectedCategory(null);
      setSearchText(searchTerm);
      navigate("/documents");
    }
  };

  // Reusable Bento-Style Card
  const IconCard = ({ icon: Icon, label, onClick, colorClass = "bg-white" }) => (
    <button 
      onClick={onClick}
      className={`${colorClass} group relative flex flex-col items-center justify-center p-6 rounded-[2rem] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(0,0,0,0.2)] shadow-sm overflow-hidden`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-transparent to-black/5 opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="p-4 rounded-2xl bg-slate-50 text-slate-800 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300 mb-4 shadow-inner">
        <Icon size={32} strokeWidth={1.5} />
      </div>
      <span className="font-bold text-slate-800 tracking-tight group-hover:text-orange-600 transition-colors">
        {label}
      </span>
    </button>
  );

  return (
    <div className="min-h-screen bg-[#0f172a] text-slate-200 selection:bg-orange-500/30">
      {/* --- HEADER --- */}
      <header className="w-full px-6 py-8 flex items-center justify-between max-w-7xl mx-auto">
        <button 
          onClick={() => setIsSidebarOpen(true)}
          className="p-3 bg-slate-800/50 border border-slate-700 rounded-2xl hover:bg-orange-500 transition-all text-white"
        >
          <Menu size={24} />
        </button>
        
        <img src={homeIMG} alt="Logo" className="h-16 md:h-20 object-contain drop-shadow-2xl" />

        <div className="w-12 h-12 hidden md:block" /> {/* Placeholder for balance */}
      </header>

      {/* --- HERO & SEARCH --- */}
      <section className="max-w-4xl mx-auto px-6 pt-4 pb-12 text-center">
        <h1 className="text-3xl md:text-5xl font-black mb-8 bg-gradient-to-b from-white to-slate-400 bg-clip-text text-transparent">
          What are you looking for?
        </h1>
        
        <div className="relative group max-w-2xl mx-auto">
          <div className="absolute -inset-1 bg-gradient-to-r from-orange-500 to-amber-500 rounded-3xl blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
          <div className="relative flex items-center bg-slate-900 border border-slate-700 rounded-2xl p-2">
            <Search className="ml-4 text-slate-500" size={20} />
            <input 
              type="text" 
              placeholder="Search by name, date or act..."
              className="w-full bg-transparent border-none focus:ring-0 px-4 py-3 text-white placeholder:text-slate-500 font-medium"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
            />
            <button 
              onClick={handleSearch}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-xl transition-all shadow-lg"
            >
              Find
            </button>
          </div>
        </div>
      </section>

      {/* --- BENTO GRID --- */}
      <main className="max-w-7xl mx-auto px-6 pb-32">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          <IconCard icon={University} label="Acts" onClick={() => handleCardClick("Act")} />
          <IconCard icon={FileSignature} label="Rules" onClick={() => handleCardClick("Rule")} />
          <IconCard icon={Megaphone} label="Directives" onClick={() => handleCardClick("Directive")} />
          <IconCard icon={FileText} label="GR" onClick={() => handleCardClick("GR")} />
          <IconCard icon={MailOpen} label="Circular" onClick={() => handleCardClick("Circulars")} />
          <IconCard icon={Scale} label="Courts" onClick={() => handleCardClick("Landmark Judgement / Orders")} />
          <IconCard icon={Landmark} label="Schemes" onClick={() => handleCardClick("Government Scheme and Policy")} />
          <IconCard icon={FileCode} label="Formats" onClick={() => handleCardClick("Formats")} />
          <IconCard icon={Book} label="Books" onClick={() => handleCardClick("Books")} />
          <IconCard icon={Newspaper} label="Articles" onClick={() => handleCardClick("Articles")} />
          <IconCard icon={GraduationCap} label="TP Career" onClick={() => handleCardClick("TP Career")} />
          <IconCard icon={Calculator} label="Calculator" onClick={() => navigate("/area-convertor")} />
        </div>
      </main>

      {/* --- NAVIGATION & MODALS --- */}
      <TownPlanningSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      
      {/* FLOATING ACTION BUTTONS */}
      <div className="fixed bottom-8 right-8 flex flex-col gap-4 z-50">
        <button 
          onClick={() => setShowFilter(true)}
          className="w-16 h-16 bg-white text-slate-900 rounded-full shadow-2xl flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all transform hover:rotate-12"
        >
          <Filter size={28} />
        </button>
        <button 
          onClick={() => setShowChatbot(!showChatbot)}
          className="w-16 h-16 bg-orange-500 text-white rounded-full shadow-2xl flex items-center justify-center hover:scale-110 transition-all shadow-orange-500/20"
        >
          {showChatbot ? <X size={28} /> : <MessageCircle size={28} />}
        </button>
      </div>

      {showChatbot && (
        <div className="fixed bottom-28 right-8 w-[90vw] md:w-[400px] h-[600px] bg-slate-900 border border-slate-700 rounded-[2rem] shadow-2xl overflow-hidden animate-in slide-in-from-bottom-10 z-[100]">
          <ChatbotPanel onClose={() => setShowChatbot(false)} />
        </div>
      )}

      {showFilter && <FilterPopup onClose={() => setShowFilter(false)} />}
    </div>
  );
}